var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.179,
    height: 45.655,
    viewBox: "0 0 35.179 45.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1,.prefix__cls-2,.prefix__cls-3{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.5px}.prefix__cls-1{stroke-linecap:round;stroke-linejoin:round}.prefix__cls-3{stroke-linecap:square}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__bottle",
    transform: "translate(-.159 -.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2",
    "data-name": "Group 2",
    transform: "translate(.909 .92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    d: "M28.5 0v31.168a5.2 5.2 0 0 1-5.181 5.195H5.181A5.2 5.2 0 0 1 0 31.168V0",
    className: "prefix__cls-1",
    transform: "translate(2.591 7.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-2",
    d: "M33.679 6.493a1.3 1.3 0 0 1-1.3 1.3H1.3a1.3 1.3 0 0 1-1.3-1.3V3.9A3.891 3.891 0 0 1 3.886 0h25.907a3.891 3.891 0 0 1 3.886 3.9z",
    className: "prefix__cls-1",
    "data-name": "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-3",
    d: "M23.214 18.181H1.3a1.3 1.3 0 0 1-1.3-1.3V1.3A1.3 1.3 0 0 1 1.3 0h21.914z",
    className: "prefix__cls-1",
    "data-name": "Shape",
    transform: "translate(7.874 15.584)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__rx",
    transform: "translate(12.838 20.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle",
    d: "M0 0h3.386a2.54 2.54 0 0 1 2.54 2.54 2.54 2.54 0 0 1-2.54 2.54H0V0z",
    className: "prefix__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line",
    d: "M.5.5v9.312",
    className: "prefix__cls-3",
    transform: "translate(-.5 -.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_2",
    d: "M.5.5l2.116 4.656",
    className: "prefix__cls-2",
    "data-name": "Line 2",
    transform: "translate(3.309 5.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_3",
    d: "M.333.269l4.515 5.47",
    className: "prefix__cls-3",
    "data-name": "Line 3",
    transform: "translate(8.414 3.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_3_Copy",
    d: "M-1.152.269l-4.515 5.47",
    className: "prefix__cls-3",
    "data-name": "Line 3 Copy",
    transform: "translate(14.414 3.768)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.5593d4d4b1f4692873abe0e04d483850.svg";
export { ForwardRef as ReactComponent };